import { PolicyApplyAndEvaluate } from '../interfaces/policy-apply-and-evaluate.interface';

/** Stub: LateReturnPolicy apply and evaluate. */
export const LateReturnPolicy: PolicyApplyAndEvaluate<
	unknown,
	number,
	unknown,
	boolean,
	Record<string, unknown>
> = {
	apply(
		_input: unknown,
		_config: Record<string, unknown> | null | undefined,
	): number {
		return 0;
	},
	evaluate(
		_input: unknown,
		_config: Record<string, unknown> | null | undefined,
	): boolean {
		return true;
	},
};
